/**
 * NotAvailable Component
 */

import * as React from 'react';
import './styles.scss';

import Page from '../../../containers/Page';

const PageNotFound = () => (
  <Page id="404">
    <h2>404 — Page Not Found</h2>
  </Page>
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/404/index.tsx